import './LoadingSpinner.css';

/**
 * Loading spinner component.
 * @returns Loading spinner component
 */
export default function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}
